import axios from 'axios';

import type { Clause } from '../../Responses/Filters/Clause';
import type { DownloadSurveyResponsesResult } from '../DownloadSurveyResponsesResult';

export type DownloadSurveyResponsesVariables = {
  siteId: number;
  surveyId: number;
  format: 'csv' | 'xlsx';
  clauses?: Clause[];
  sortBy?: string;
  isAsyncExport?: boolean;
};

export async function downloadSurveyResponses({
  siteId,
  surveyId,
  format,
  clauses,
  sortBy,
  isAsyncExport,
}: DownloadSurveyResponsesVariables): Promise<DownloadSurveyResponsesResult> {
  const response = await axios.get<DownloadSurveyResponsesResult>(
    `/api/v3/sites/${siteId}/polls/${surveyId}/responses/export`,
    {
      params: {
        survey_query: { sort_by: sortBy, clauses },
        format,
        async_export: isAsyncExport,
      },
    },
  );
  return response.data;
}
